{
  "Accessibility Menu": "เมนูการช่วยการเข้าถึง",
  "Reset settings": "รีเซ็ตการตั้งค่า",
  "Close": "ปิด",
  "Content Adjustments": "การปรับเนื้อหา",
  "Adjust Font Size": "ปรับขนาดตัวอักษร",
  "Highlight Title": "เน้นหัวเรื่อง",
  "Highlight Links": "เน้นลิงก์",
  "Readable Font": "แบบอักษรที่อ่านง่าย",
  "Color Adjustments": "การปรับสี",
  "Dark Contrast": "ความเปรียบต่างเข้ม",
  "Light Contrast": "ความเปรียบต่างสว่าง",
  "High Contrast": "ความเปรียบต่างสูง",
  "High Saturation": "ความอิ่มตัวของสีสูง",
  "Low Saturation": "ความอิ่มตัวของสีต่ำ",
  "Monochrome": "โมโนโครม",
  "Contrast": "ความคมชัด",
  "Invert Colors": "กลับสี",
  "Tools": "เครื่องมือ",
  "Reading Guide": "คู่มือการอ่าน",
  "Stop Animations": "หยุดการเคลื่อนไหว",
  "Big Cursor": "เคอร์เซอร์ขนาดใหญ่",
  "Increase Font Size": "เพิ่มขนาดตัวอักษร",
  "Decrease Font Size": "ลดขนาดตัวอักษร",
  "Letter Spacing": "ระยะห่างระหว่างตัวอักษร",
  "Line Height": "ความสูงของบรรทัด",
  "Font Weight": "น้ำหนักตัวอักษร",
  "Dyslexia Font": "แบบอักษรสำหรับดิสเล็กเซีย",
  "Language": "ภาษา",
  "Open Accessibility Menu": "เปิดเมนูการช่วยการเข้าถึง",
  "Widget Settings": "การตั้งค่าวิดเจ็ต",
  "Widget Position": "ตำแหน่งวิดเจ็ต",
  "Top Left": "ซ้ายบน",
  "Top Center": "กลางบน",
  "Top Right": "ขวาบน",
  "Center Left": "กลางซ้าย",
  "Center Right": "กลางขวา",
  "Bottom Left": "ซ้ายล่าง",
  "Bottom Center": "กลางล่าง",
  "Bottom Right": "ขวาล่าง",
  "Screen Reader": "โปรแกรมอ่านหน้าจอ",
  "Voice Navigation": "การนำทางด้วยเสียง",
  "Custom Color": "สีที่กำหนดเอง",
  "Change the site's colors": "เปลี่ยนสีของเว็บไซต์",
  "Backgrounds": "พื้นหลัง",
  "Headings": "หัวเรื่อง",
  "Contents": "เนื้อหา",
  "Reset colors": "รีเซ็ตสี",
  "Image Desaturation": "ลดความอิ่มตัวของภาพ",
  "Search languages": "ค้นหาภาษา",
  "No languages found": "ไม่พบภาษา",
  "Accessibility Profiles": "โปรไฟล์การช่วยการเข้าถึง",
  "Motor Impaired": "ผู้มีข้อจำกัดการเคลื่อนไหว",
  "Big cursor, voice navigation, and no animations.": "เคอร์เซอร์ขนาดใหญ่ นำทางด้วยเสียง และไม่มีแอนิเมชัน",
  "Blind": "ผู้พิการทางสายตา",
  "Screen reader helpers with higher contrast.": "ผู้ช่วยโปรแกรมอ่านหน้าจอที่มีคอนทราสต์สูงขึ้น",
  "Color Blind": "ตาบอดสี",
  "High contrast palette with desaturated media.": "พาเล็ตคอนทราสต์สูงพร้อมสื่อที่ลดความอิ่มสี",
  "Dyslexia": "ดิสเล็กเซีย",
  "Friendly font, extra spacing, stronger weight.": "ฟอนต์อ่านง่าย ระยะห่างเพิ่ม และน้ำหนักตัวอักษรหนา",
  "Low vision": "สายตาพิการ",
  "Dark contrast and 130% magnification.": "คอนทราสต์มืดและขยาย 130%",
  "Cognitive & Learning": "การรับรู้และการเรียนรู้",
  "Highlights key sections and enables voice help.": "ไฮไลต์ส่วนสำคัญและเปิดใช้งานผู้ช่วยเสียง",
  "Seizure & Epileptic": "อาการชักและลมชัก",
  "Stops animations and desaturates imagery.": "หยุดแอนิเมชันและลดสีของภาพ",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "คู่มือการอ่าน ลิงก์ที่ไฮไลต์ และโทนสีที่สงบกว่า",
  "Widget Size": "ขนาดวิดเจ็ต",
  "Default": "ค่าเริ่มต้น",
  "Medium": "ปานกลาง",
  "Small": "เล็ก",
  "Color Blindness": "ตาบอดสี",
  "Protanopia": "ตาบอดสีแดง",
  "Deuteranopia": "ตาบอดสีเขียว",
  "Tritanopia": "ตาบอดสีน้ำเงิน",
  "Achromatopsia": "ตาบอดสีทั้งหมด",
  "Simulates and assists users with color vision deficiencies.": "จำลองและช่วยเหลือผู้ใช้ที่มีความบกพร่องทางการมองเห็นสี"
}
